import * as React from 'react';

import { cn } from '../../lib/utils';

const TypographyH4 = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/heading-has-content
  <h4
    ref={ref}
    className={cn('scroll-m-20 text-display-md font-regular', className)}
    {...props}
  />
));
TypographyH4.displayName = 'TypographyH4';

export { TypographyH4 };
